export const getAccessInitialState = {
	access: null,
	error: null,
	errorShow: false,
	loading: false,
};
